import { Button, Collapse, Typography } from 'antd';
import React, { useMemo, useState } from 'react'
import LilyButton from '../../../../../components/button/lily-button';
import UploadFile from '../../../../../components/upload/upload-file';
import { useClaimContext } from '../../component/claim-context';
import BenefitExample from '../../../../../assets/benefit-example.jpg';

const ExplanationOfBenefits = (props) => {
    const { caseType, setCurrentType } = props;
    const { Title, Text } = Typography;
    const [isUploading, setIsUploading] = useState(false);
    const [isNext, setIsNext] = useState(false);

    const { setClaimForm, claimForm, setSupportOptions } = useClaimContext();

    const handleSubmit = () => {
        setSupportOptions((prev) =>
            prev.map((item) =>
                item.value === caseType ? { ...item, checked: noInform } : item
            )
        );
        setCurrentType('')
    };

    const noInform = useMemo(() => claimForm?.eob.length !== 0, [claimForm]);

    return (
        <div className='d-flex flex-column gap-4'>
            <Title className='mb-1 main-title' level={3}>
                Explanation of Benefits (EOB)
            </Title>
            <Text>
                The explanation of benefits with the amount paid for this prescription clearly identified.
            </Text>
            <UploadFile fieldKey="eob" uploadedFiles={claimForm.eob} setClaimForm={setClaimForm} setIsUploading={setIsUploading} setIsNext={setIsNext} />
            <Collapse
                style={{ backgroundColor: 'white' }}
                collapsible="header"
                items={[
                    {
                        key: '1',
                        label: 'View Explanation of Benefit Example',
                        children: (<div className='d-flex align-items-center justify-content-center'>
                            <img width='100%' src={BenefitExample} alt='EOB Example' />
                        </div>)
                    },
                ]}
            />
            <div className='d-flex flex-row justify-content-end mt-5'>
                <Button
                    color="default"
                    variant="link"
                    style={{ width: '200px' }}
                    disabled={isUploading}
                    onClick={handleSubmit}
                >
                    Back
                </Button>
                <LilyButton disabled={!noInform || isUploading || !isNext} style={{ width: '200px' }} onClick={handleSubmit} text="Next" />
            </div>
        </div>
    )
}

export default ExplanationOfBenefits